import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import axios from 'axios';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAppAuthStore();
  const isProcessing = useRef(false); // 실행 플래그

  const handleLogin = async () => {
    if (isProcessing.current) return;
    isProcessing.current = true;

    // ⭐ URL 파라미터에서 토큰 추출
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');
    const error = searchParams.get('error');
    if (error) {
      if (error === 'DEACTIVATED_USER') {
        alert('탈퇴한 회원입니다. 다른 계정을 사용해주세요.');
        navigate('/login');
        return;
      }

      // 에러 처리
      alert('로그인에 실패했습니다.');
      navigate('/login');
      return;
    }

    if (accessToken && refreshToken) {
      const response = await axios.get('/api/app/members/me', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const member = response.data;
      // Store에 저장

      login(accessToken, refreshToken, member);
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      navigate('/');
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);
};

export default AuthCallbackPage;
